import { CheckboxProps } from 'core/checkbox/checkbox.props';

export const CheckboxPresets: CheckboxProps = {
  checked: false,
  labelPosition: 'right',
  labelVariant: 'p3',
};
